import { QueryClientProvider } from "@tanstack/react-query";
import { memo, type ReactNode } from "react";
import { reactQueryClient } from "./react-query-config";

interface RpcQueryProviderProps {
  children: ReactNode;
}

/**
 * Provider that wraps QueryClientProvider to enable React Query functionality
 * for RPC hooks. This should be placed at the root of your application.
 *
 * @example
 * ```tsx
 * import { RpcQueryProvider } from "@redotech/redo-web/rpc-query/rpc-query-provider";
 *
 * function App() {
 *   return (
 *     <RpcQueryProvider>
 *       {// Your app components}
 *     </RpcQueryProvider>
 *   );
 * }
 * ```
 */
export const RpcQueryProvider = memo(function RpcQueryProvider({
  children,
}: RpcQueryProviderProps) {
  return (
    <QueryClientProvider client={reactQueryClient}>
      {children}
    </QueryClientProvider>
  );
});

// Re-export QueryClientProvider for advanced use cases where UIs need custom configuration
// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export { QueryClientProvider, useQueryClient } from "@tanstack/react-query";
// eslint-disable-next-line @redotech/no-re-exports -- TODO: remove re-export, update all import sites
export type { QueryClient } from "@tanstack/react-query";
